export const translations = {
  'it-IT': {
    translation: {
      showToday: 'Mostrare oggi',
      outOfRange: 'Fuori intervallo',
      selectUpToDays: 'Seleziona data entro {maxDays} giorni',
      From: 'Da',
      FromToDateRangeError: `Alla data non può essere precedente rispetto a Dalla data`,
      to: 'A',
      dateFrom: 'Data iniziale',
      loadingError: 'Errore di caricamento',
      contactAdmin:
        "Aggiornare la pagina per caricare i dati. Contattare l'amministratore se il problema persiste.",
      searchFor: 'Cerca',
      nodes: 'Nodi',
      cancel: 'Annulla',
      back: 'Indietro',
      saveAndContinue: 'Salva e continua',
      yes: 'Sì',
      no: 'No',
      selectDateRange: 'Select the date range between {days} days',
      Today: 'Today',
      Yesterday: 'Yesterday',
      LastWeek: 'Last Week',
      ThisMonth: 'This Month',
      LastMonth: 'Last Month',
      Last3Months: 'Last 3 Months',
      Last6Months: 'Last 6 Months',
      YearToDate: 'Year To Date',
      LastYear: 'Last Year',
      datePickerErrorMsg: 'Please select the dates within {days} months range.',
      datePickerGreaterErrorMessage: 'From Date cannot be greater than To Date',
      Duration: 'Duration',
      To: 'To',
      apply: 'Apply'
    }
  }
};
